module.exports = __webpack_public_path__ + "4e8c6af07343238bfa9094a9376f7a48.png";